import { useEffect, useState } from "react";
import { UserPlus, UserCheck, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const FollowButton = ({ sellerName, size = "default" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [following, setFollowing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);
  const isSelf = user && user.display_name === sellerName;

  useEffect(() => {
    if (!user || isSelf) return;
    setLoading(true);
    api
      .get(`/follow/status/${encodeURIComponent(sellerName)}`)
      .then((res) => setFollowing(res.data.following))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user, sellerName, isSelf]);

  if (isSelf) return null;

  const toggle = async () => {
    if (!user) {
      navigate("/login");
      return;
    }
    setBusy(true);
    try {
      if (following) {
        await api.delete(`/follow/${encodeURIComponent(sellerName)}`);
        setFollowing(false);
        toast.success(`Unfollowed ${sellerName}`);
      } else {
        await api.post(`/follow/${encodeURIComponent(sellerName)}`);
        setFollowing(true);
        toast.success(`Following ${sellerName}`);
      }
    } catch {
      toast.error("Could not update follow");
    } finally {
      setBusy(false);
    }
  };

  const height = size === "sm" ? "h-9" : "h-11";

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy || loading}
      data-testid={`follow-btn-${sellerName}`}
      className={`inline-flex items-center gap-2 rounded-full px-5 ${height} text-sm font-semibold transition-colors ${
        following
          ? "bg-white border border-primary text-primary"
          : "bg-primary text-primary-foreground hover:bg-primary/90"
      }`}
    >
      {busy || loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : following ? (
        <UserCheck className="h-4 w-4" strokeWidth={2.2} />
      ) : (
        <UserPlus className="h-4 w-4" strokeWidth={2.2} />
      )}
      {following ? "Following" : "Follow"}
    </button>
  );
};
